import React, { useRef, useState, useCallback, useEffect } from "react";
import { MoveLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dropdown,
  Button,
  Spinner,
  ToastContainer,
  Toast,
} from "react-bootstrap";
import DOMPurify from "dompurify";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import deleteIcon from "../../assets/svg/delete-po.svg";
import {
  submitTripsAPI,
  updateTripsAPI,
  getTripsEditApi,
  getVehicleDetailApi,
  getCustomerAutoCompleteApi,
  getFromAddressAutoCompleteApi,
  getToAddressAutoCompleteApi,
  getStopsApi,
  getSortedStopsApi,
  getDefaultMilestoneApi,
} from "./trips-api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { v4 as uuidv4 } from "uuid";
import MultiSelectDropdown from "../common/commonMultiDropDown";
import AsyncSelect from "react-select/async";
import CustomDateRangePicker from "../common/dateRangeCustom";
import { format } from "date-fns";
import CommonStaticDropdown from "../common/common_static_dropdown";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import totalAmtIc from "../../assets/svg/total_amount.svg";
import totalKMIc from "../../assets/svg/total_km.svg";
import totalVolumeIc from "../../assets/svg/total_volume.svg";
import totalPackageIc from "../../assets/svg/total_package.svg";
import totalWeightIc from "../../assets/svg/total_weight.svg";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";

export const TripsCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  const location = useLocation();
  const navigate = useNavigate();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null) {
      getTripsEdit(id);
    } else {
      getStops();
      getDefaultMilestone();
    }
  }, [id]);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [isApplyLoading, setIsApplyLoading] = useState(false);
  const [isSortLoading, setIsSortLoading] = useState(false);
  const [milestoneOption, setMilestoneOption] = useState(null);
  const [VINOption, setVINOption] = useState(null);
  const [vehicleDetails, setVehicleDetails] = useState({});
  const [vendorOption, setVendorOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);

  const [customerOption, setCustomerOption] = useState([]);
  const [fromAddressOption, setFromAddressOption] = useState([]);
  const [toAddressOption, setToAddressOption] = useState([]);

  const [selectedTab, setSelectedTab] = useState("Driver");
  const [typeOption, setTypeOption] = useState(null);
  const [typeValue, setTypeValue] = useState("");

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalKM, setTotalKM] = useState(0);
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalPackage, setTotalPackage] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);

  const [stopsList, setStopsList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    const updatedData = stopsList.map((row) => ({
      ...row,
      selected: newSelectAll,
    }));
    setSelectAll(newSelectAll);
    setStopsList(updatedData);
  };

  const handleRowSelect = (index) => {
    const updatedData = [...stopsList];
    updatedData[index].selected = !updatedData[index].selected;
    setStopsList(updatedData);
    setSelectAll(updatedData.every((row) => row.selected));
  };

  const [errorMsg, setErrorMsg] = useState({
    milestone_id: "",
    location_id: "",
    vehicle_id: "",
    vendor_id: "",
    stops: "",
  });

  const [driverList, setDriverList] = useState([]);

  const [groupedError, setGroupedError] = useState({});
  const [removedDriverList, setRemovedDriverList] = useState([]);

  const getErrorMsg = (index, field) => {
    if (field === "contact_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].contact_id != null) {
          return (
            groupedError[index].contact_id[0]?.replace(
              `contacts.${index}.contact_id`,
              "contact"
            ) ?? ""
          );
        }
      }
    }
    if (field === "mobile_number") {
      if (groupedError[index] != null) {
        if (groupedError[index].mobile_number != null) {
          return (
            groupedError[index].mobile_number[0]?.replace(
              `contacts.${index}.mobile_number`,
              "mobile_number"
            ) ?? ""
          );
        }
      }
    }
    if (field === "start_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].start_date != null) {
          return (
            groupedError[index].start_date[0]?.replace(
              `contacts.${index}.start_date`,
              "start date"
            ) ?? ""
          );
        }
      }
    }

    if (field === "end_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].end_date != null) {
          return (
            groupedError[index].end_date[0]?.replace(
              `contacts.${index}.end_date`,
              "end date"
            ) ?? ""
          );
        }
      }
    }

    if (field === "quantity") {
      if (groupedError[index] != null) {
        if (groupedError[index].quantity != null) {
          return (
            groupedError[index].quantity[0]?.replace(
              `products.${index}.quantity`,
              "quantity"
            ) ?? ""
          );
        }
      }
    }

    if (field === "price") {
      if (groupedError[index] != null) {
        if (groupedError[index].price != null) {
          return (
            groupedError[index].price[0]?.replace(
              `products.${index}.price`,
              "price"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };

  const submitForm = async () => {
    setIsSaveLoading(true);
    const extractor = new ErrorExtractor();

    try {
      const updatedDriverData = driverList.map((item) => ({
        ...item,
        contact_id: item.contact != null ? item.contact.value : "",
      }));

      const preSanitizeData = {
        milestone_id: milestoneOption != null ? milestoneOption.value : "",
        location_id: locationOption != null ? locationOption.value : "",
        vehicle_id: VINOption != null ? VINOption.value : "",
        vendor_id: vendorOption != null ? vendorOption.value : "",
        total_amount: totalAmount,
        total_kilometer: totalKM,
        total_volume: totalVolume,
        total_weight: totalWeight,
        total_package: totalPackage,

        stops: stopsList
          .filter(
            (item) =>
              item.selected === true &&
              item.sequence != null &&
              item.sequence !== ""
          )
          .map((item) => ({
            id: item.id ?? "",
            stop_id: item.stop_id,
            sequence: item.sequence,
          })),
        contacts: updatedDriverData,
        removeId: removedDriverList,
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value)
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitTripsAPI(sanitizedData);
      } else {
        response = await updateTripsAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        /* const errorvalue = extractor.extractErrors(response.data.error, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue); */
        new Promise((resolve, reject) => {
          const validationTemp = {
            milestone_id: "",
            location_id: "",
            vehicle_id: "",
            vendor_id: "",
            stops: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        navigate(-1);
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            milestone_id: "",
            location_id: "",
            vehicle_id: "",
            vendor_id: "",
            stops: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(err.response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        new Promise((resolve, reject) => {
          const validationTemp = {
            milestone_id: "",
            location_id: "",
            vehicle_id: "",
            vendor_id: "",
            stops: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      }
    } finally {
      setIsSaveLoading(false);
    }
  };

  const getDefaultMilestone = async () => {
    try {
      const response = await getDefaultMilestoneApi();

      if (response.data.success === true) {
        const defaultDetail = response.data.milestone ?? {};
        setMilestoneOption({
          value: defaultDetail.value,
          label: defaultDetail.label,
        });
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTripsEdit = async (id) => {
    try {
      const response = await getTripsEditApi(id);

      console.log("Trip Edit API Response:", response.data);

      if (response.data.success === true) {
        const tripDetail = response.data.trip ?? {};
        setMilestoneOption({
          value: tripDetail.milestone_id,
          label: tripDetail.milestone,
        });
        setLocationOption({
          value: tripDetail.location_id,
          label: tripDetail.location,
        });
        setVINOption({ value: tripDetail.vehicle_id, label: tripDetail.vin });
        setVendorOption({
          value: tripDetail.vendor_id,
          label: tripDetail.vendor,
        });
        setVehicleDetails({
          vehicle_type: tripDetail.vehicle_type,
          license_plate: tripDetail.license_plate,
        });

        const tempDriver = response.data.driver ?? [];
        const tempCoDriver = response.data.co_driver ?? [];
        const tempDelivery = response.data.delivery_person ?? [];

        console.log("Raw Driver Data:", tempDriver);
        console.log("Raw Co-Driver Data:", tempCoDriver);
        console.log("Raw Delivery Person Data:", tempDelivery);

        const transformDriverData = (drivers, contactType) => {
          return drivers.map((driver) => ({
            id: driver.id ?? 0,
            contact_type: contactType,
            contact: driver.contact_id
              ? {
                  value: driver.contact_id,
                  label: driver.driver_name || "",
                }
              : null,
            mobile_number: driver.mobile_number || "",
            start_date: driver.start_date || "",
            end_date: driver.end_date || "",
          }));
        };

        const transformedDrivers = transformDriverData(tempDriver, "Driver");
        const transformedCoDrivers = transformDriverData(
          tempCoDriver,
          "coDriver"
        );
        const transformedDelivery = transformDriverData(
          tempDelivery,
          "deliveryPerson"
        );

        const allDrivers = [
          ...transformedDrivers,
          ...transformedCoDrivers,
          ...transformedDelivery,
        ];

        console.log("Transformed Driver List:", allDrivers);
        setDriverList(allDrivers);

        getStops();
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getVehicleDetails = async (id) => {
    const response = await getVehicleDetailApi(id);

    if (response.data.success === true) {
      setVehicleDetails(response.data.vehicle ?? {});
    }
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
        ? "#e0e0e0"
        : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const fetchOptionsAutoCustomer = async (inputValue, callback) => {
    try {
      const response = await getCustomerAutoCompleteApi(inputValue);

      if (response.data.success === true) {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      }
    } catch (err) {
      callback([]);
    } finally {
    }
    /*  axios
      .get(`${apiUrl}get_vendor?&term=${inputValue || ""}`, {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          Authorization: getCookie("mawalog"),
        },
      })
      .then((response) => {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options); // ✅ Must call callback to update AsyncSelect
      })
      .catch((error) => {
        console.error("API Error:", error);
        callback([]); // return empty on error
      }); */
  };

  const fetchFromAddress = async (inputValue, callback) => {
    try {
      const response = await getFromAddressAutoCompleteApi(inputValue);

      if (response.data.success === true) {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      }
    } catch (err) {
      callback([]);
    } finally {
    }
  };

  const fetchToAddress = async (inputValue, callback) => {
    try {
      const response = await getToAddressAutoCompleteApi(inputValue);

      if (response.data.success === true) {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      }
    } catch (err) {
      callback([]);
    } finally {
    }
  };
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  useEffect(() => {
    getStops();
  }, [locationOption, itemsPerPage, itemOffset]);

  const getStops = async () => {
    try {
      const preSanitizeData = {
        limit: itemsPerPage,
        skip: itemOffset * itemsPerPage,
        trip_id: id ?? "",
        type: typeOption !== null ? typeOption.value : "",
        value: typeValue,
        location_id: locationOption !== null ? locationOption.value : "",
        fromCreatedDate: startDateSave,
        toCreatedDate: endDateSave,
        customer: customerOption
          .filter((item) => item.value !== null)
          .map((item) => item.value),
        fromAddress: fromAddressOption
          .filter((item) => item.value !== null)
          .map((item) => item.value),
        toAddress: toAddressOption
          .filter((item) => item.value !== null)
          .map((item) => item.value),
      };
      const response = await getStopsApi(preSanitizeData);

      if (response.data.success === true) {
        const stops = response.data.stops ?? [];

        const updatedStops =
          id != null
            ? stops.map((stop) => ({
                ...stop,
                selected:
                  stop.sequence != null && stop.sequence > 0
                    ? true
                    : stop.selected || false,
              }))
            : stops;

        setStopsList(updatedStops);
        setPageCount(response.data.pages ?? 0);
        setTotalCount(response.data.totalrecords ?? 0);
        setTotalAmount(response.data.totalprice ?? 0);
        setTotalKM(response.data.totalkm ?? 0);
        setTotalVolume(response.data.totalvoulme ?? 0);
        setTotalPackage(response.data.totalpackage ?? 0);
        setTotalWeight(response.data.totalweight ?? 0);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getSortedStops = async () => {
    try {
      setIsSortLoading(true);
      const preSanitizeData = {
        stop_id: stopsList
          .filter((item) => item.selected === true)
          .map((item) => item.stop_id),
      };
      const response = await getSortedStopsApi(preSanitizeData);

      if (response.data.success === true) {
        const sortedList = response.data.sorted_stops ?? [];

        const updatedArray = stopsList.map((item) => {
          const match = sortedList.find((el) => el.id === item.stop_id);
          console.log("match", match);
          console.log("sortedList", sortedList);
          if (match) {
            return {
              ...item,
              sequence: match.sequence,
              error: match.error || null,
            };
          }
          return {
            ...item,
            error: null,
          };
        });
        setStopsList(updatedArray ?? []);
        setIsSortLoading(false);
        setToast({
          show: true,
          message: "Stops sorted successfully",
          variant: "success",
        });
      } else {
        setIsSortLoading(false);
        setToast({
          show: true,
          message: "Stops sorted failed",
          variant: "danger",
        });
      }
      return response.data;
    } catch (err) {
      setIsSortLoading(false);
      setToast({
        show: true,
        message: "Stops sorted failed",
        variant: "danger",
      });
    } finally {
      setIsSortLoading(false);
    }
  };

  return (
    <div className="d-flex ">
      <Sidebar currentfile="Trips" />
      <div
        className="rounded-4 flex-grow-1  "
        style={{ width: "calc(100vw - 80px)" }}
      >
        <Navbar pageTitle="Trips" />

        <div
          className="scroll-hidden"
          style={{ background: "#F5F8FA", height: "calc(100vh - 56px)" }}
        >
          <div className="px-2 d-flex align-items-center justify-content-between">
            <div className="d-flex gap-3 my-3">
              <MoveLeft
                className="cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              />
              <p className="fw-semibold m-0">New trip</p>
            </div>
            <div className="d-flex gap-3">
              <Button
                className="cursor-pointer bg-white rounded-pill px-4 py-2  btn-border-grey fs-15 fw-500"
                style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                className={`cursor-pointer dark-purple-btn ${
                  isSaveLoading ? "disabled-btn" : ""
                } rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                onClick={() => {
                  submitForm();
                }}
                style={{ minWidth: "100px" }}
              >
                {isSaveLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : id != null ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </div>
          <div className="col-12 px-2">
            <div className="row mb-2 mx-0">
              <div className="col-12 col-md-6 pe-0 ">
                <div className="bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    Trip details
                  </div>

                  <div className="mt-2 col-12  d-flex flex-column align-items-start">
                    <div
                      className="form-label fs-12 fw-400 my-0 mb-1"
                      style={{ color: "#28303F" }}
                    >
                      Milestone <span className="error-text">*</span>
                    </div>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${apiUrl}milestone/autosuggestion`}
                        placeholder="Select"
                        value={milestoneOption}
                        onSelect={(item) => {
                          setMilestoneOption(item);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.milestone_id}
                    </span>
                  </div>

                  <div className="mt-2 col-12  d-flex flex-column align-items-start">
                    <div
                      className="form-label fs-12 fw-400 my-0 mb-1"
                      style={{ color: "#28303F" }}
                    >
                      Location <span className="error-text">*</span>
                    </div>
                    <div className="w-100">
                      <CommonDropdown
                        apiUrl={`${adminUrl}get_location`}
                        placeholder="Select"
                        value={locationOption}
                        onSelect={(item) => {
                          setLocationOption(item);
                        }}
                      />
                    </div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.location_id}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 pe-0">
                <div className="bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    Vehicle details
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          VIN <span className="error-text">*</span>
                        </div>
                        <div className="w-100">
                          <CommonDropdown
                            apiUrl={`${apiUrl}vehicle/autosuggestion`}
                            placeholder="Select"
                            value={VINOption}
                            onSelect={(item) => {
                              setVINOption(item);
                              getVehicleDetails(item.value);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.vehicle_id}
                        </span>
                      </div>
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start  ps-0">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          License Plate
                        </div>

                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {vehicleDetails.license_plate}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="row">
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Vehicle Type
                        </div>
                        <div
                          className="w-100 rounded-3 px-2 d-flex align-items-center justify-content-start"
                          style={{ height: "40px", background: "#F8F8F8" }}
                        >
                          {" "}
                          <span
                            className="fs-14 fw-300 "
                            style={{ color: "#8790A1" }}
                          >
                            {vehicleDetails.vehicle_type}
                          </span>
                        </div>
                      </div>
                      <div className="mt-2 col-12 col-lg-6  d-flex flex-column align-items-start ps-0">
                        <div
                          className="form-label fs-12 fw-400 my-0 mb-1"
                          style={{ color: "#28303F" }}
                        >
                          Vendor
                        </div>
                        <div className="w-100">
                          <CommonDropdown
                            apiUrl={`${apiUrl}vendor/autosuggestion`}
                            placeholder="Select"
                            value={vendorOption}
                            onSelect={(item) => {
                              setVendorOption(item);
                            }}
                          />
                        </div>
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                            marginTop: "6px",
                            marginLeft: "6px",
                          }}
                        >
                          {errorMsg.vendor_id}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="m-2 bg-white rounded-4 p-3">
              <div className="row">
                <div className="col-12 ">
                  <div className="row">
                    <div className="w-100 mb-1  d-flex align-items-center justify-content-start gap-2">
                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "Driver"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          width: "110px",
                          color:
                            selectedTab === "Driver" ? "#FFFFFF" : "#172B4D",
                          background:
                            selectedTab === "Driver" ? "#3469E7" : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("Driver");
                        }}
                      >
                        Driver
                      </div>
                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "coDriver"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          minWidth: "110px",
                          color:
                            selectedTab === "coDriver" ? "#FFFFFF" : "#172B4D",
                          background:
                            selectedTab === "coDriver" ? "#3469E7" : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("coDriver");
                        }}
                      >
                        Co-Driver
                      </div>

                      <div
                        className={`cursor-pointer d-flex align-items-center justify-content-center rounded-3  px-2 fs-13  ${
                          selectedTab === "deliveryPerson"
                            ? "fw-500 active-bottom-bar "
                            : " fw-400"
                        } `}
                        style={{
                          height: "32px",
                          minWidth: "110px",
                          color:
                            selectedTab === "deliveryPerson"
                              ? "#FFFFFF"
                              : "#172B4D",
                          background:
                            selectedTab === "deliveryPerson"
                              ? "#3469E7"
                              : "#F5F5F5",
                        }}
                        onClick={() => {
                          setSelectedTab("deliveryPerson");
                        }}
                      >
                        Delivery Person
                      </div>
                    </div>

                    <>
                      <div style={{ overflowY: "visible" }}>
                        <div className="mt-2 sticky-table-wrapper ">
                          <table
                            className="stop-table"
                            border="1"
                            cellPadding="10"
                            style={{
                              borderCollapse: "collapse",
                              width: "100%",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <thead
                              style={{
                                height: "48px",
                                color: "#8790A1",
                                fontSize: "11px",
                                fontWeight: "400",
                                textAlign: "left",
                              }}
                            >
                              <tr>
                                <th className="ps-2">
                                  {selectedTab === "Driver"
                                    ? "DRIVER"
                                    : selectedTab === "coDriver"
                                    ? "CO-DRIVER"
                                    : "DELIVER PERSON"}
                                </th>
                                <th className="ps-2">MOBILE NUMBER</th>
                                <th className="ps-2">STARTS ON</th>
                                <th className="ps-2">ENDS ON</th>
                                <th className="ps-2"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {driverList
                                .filter(
                                  (row) => row.contact_type === selectedTab
                                )
                                .map((row, index1) => (
                                  <tr
                                    key={row.id}
                                    style={{
                                      height: "60px",
                                      position: "relative",
                                      overflow: "visible",
                                    }}
                                  >
                                    <td
                                      className="px-2 py-1"
                                      style={{
                                        position: "relative",
                                        overflow: "visible",
                                      }}
                                    >
                                      <div
                                        className="pe-3 py-1"
                                        style={{ width: "200px" }}
                                      >
                                        {" "}
                                        <CommonDropdown
                                          apiUrl={`${adminUrl}get_driver`}
                                          placeholder="Select"
                                          value={row.contact}
                                          onSelect={(item) => {
                                            const index = driverList.findIndex(
                                              (item) => item.uid === row.uid
                                            );
                                            if (index > -1) {
                                              const tempList = [...driverList];
                                              tempList[index]["contact"] = item;
                                              setDriverList(tempList);
                                            }
                                          }}
                                        />
                                        <span className="fs-12 fw-400 cardTextRed">
                                          {getErrorMsg(index1, "contact_id")}
                                        </span>
                                      </div>
                                    </td>
                                    <td className="px-2 py-1">
                                      <input
                                        type="text"
                                        className="form-control rounded-3 vendor-form-input"
                                        id={`mobile` + index1}
                                        placeholder="Enter here"
                                        value={row.mobile_number}
                                        onChange={(e) => {
                                          const index = driverList.findIndex(
                                            (item) => item.uid === row.uid
                                          );
                                          if (index > -1) {
                                            const tempList = [...driverList];
                                            tempList[index]["mobile_number"] =
                                              e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");
                                            setDriverList(tempList);
                                          }
                                        }}
                                        style={{
                                          borderColor:
                                            getErrorMsg(
                                              index1,
                                              "mobile_number"
                                            ) !== ""
                                              ? "red"
                                              : "#EBEBEB",
                                        }}
                                      />{" "}
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "mobile_number")}
                                      </span>
                                    </td>

                                    <td className="px-2 py-1">
                                      <input
                                        type="datetime-local"
                                        className="date-time-input"
                                        value={row.start_date}
                                        onChange={(e) => {
                                          const index = driverList.findIndex(
                                            (item) => item.uid === row.uid
                                          );
                                          if (index > -1) {
                                            const tempList = [...driverList];
                                            tempList[index]["start_date"] =
                                              e.target.value;
                                            setDriverList(tempList);
                                          }
                                        }}
                                        style={{
                                          padding: "6px",
                                          borderRadius: "6px",
                                        }}
                                      />
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "start_date")}
                                      </span>
                                    </td>

                                    <td
                                      className="px-2 py-1"
                                      style={{ width: "150px" }}
                                    >
                                      <input
                                        type="datetime-local"
                                        className="date-time-input"
                                        value={row.end_date}
                                        onChange={(e) => {
                                          const index = driverList.findIndex(
                                            (item) => item.uid === row.uid
                                          );
                                          if (index > -1) {
                                            const tempList = [...driverList];
                                            tempList[index]["end_date"] =
                                              e.target.value;
                                            setDriverList(tempList);
                                          }
                                        }}
                                        style={{
                                          padding: "6px",
                                          borderRadius: "6px",
                                        }}
                                      />
                                      <span className="fs-12 fw-400 cardTextRed">
                                        {getErrorMsg(index1, "end_date")}
                                      </span>
                                    </td>

                                    <td>
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "14px",
                                        }}
                                        onClick={() => {
                                          if (
                                            row.id !== null &&
                                            row.id !== ""
                                          ) {
                                            setRemovedDriverList([
                                              ...removedDriverList,
                                              row.id,
                                            ]);
                                          }
                                          const index = driverList.findIndex(
                                            (item) => item.uid === row.uid
                                          );
                                          if (index > -1) {
                                            driverList.splice(index, 1);
                                            setDriverList(driverList);
                                          }
                                        }}
                                        className="mx-2 ps-2 d-flex align-items-center justify-content-center "
                                      >
                                        <img src={deleteIcon} alt="delete" />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-xl-12 mt-2">
                        <Button
                          className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                          onClick={() => {
                            setDriverList([
                              ...driverList,
                              {
                                id: 0,
                                contact_type:
                                  selectedTab === "Driver"
                                    ? "Driver"
                                    : selectedTab === "coDriver"
                                    ? "coDriver"
                                    : "deliveryPerson",
                                contact: null,
                                mobile_number: "",
                                start_date: "",
                                end_date: "",
                                uid: uuidv4(),
                              },
                            ]);
                          }}
                          style={{
                            minWidth: "100px",
                            background: "#E6E4FF",
                            color: "#212129",
                            fontWeight: "600",
                            fontSize: "13px",
                          }}
                        >
                          Add driver
                        </Button>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 bg-white rounded-4 ">
              <div className="m-2 bg-white rounded-4 d-flex flex-column align-items-start px-2 py-2">
                <div className="w-100 d-flex align-items-center justify-content-between">
                  <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                    Filter Stops
                  </div>
                  <div className="d-flex gap-3">
                    <Button
                      className="cursor-pointer bg-white rounded-3 px-3 py-2  btn-border-grey fs-15 fw-500"
                      style={{ border: "1px solid #D4DDE7", color: "#212129" }}
                      onClick={() => {
                        setCustomerOption([]);
                        setFromAddressOption([]);
                        setToAddressOption([]);
                        setTypeOption({
                          value: "",
                          label: "Select",
                        });
                        setTypeValue("");
                        setStartDateSave(null);
                        setEndDateSave(null);
                        setStartDate(null);
                        setEndDate(null);
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      className={`cursor-pointer dark-purple-btn ${
                        isApplyLoading ? "disabled-btn" : ""
                      } rounded-3 py-2 px-2 d-flex justify-content-center align-items-center fs-15 fw-500`}
                      onClick={async () => {
                        setIsApplyLoading(true);
                        await getStops();
                        setIsApplyLoading(false);
                      }}
                      style={{ minWidth: "100px" }}
                    >
                      {isApplyLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Apply"
                      )}
                    </Button>
                  </div>
                </div>
                <div className="col-12 ">
                  <div className="row ">
                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        Customer
                      </div>
                      <div className="w-100">
                        <AsyncSelect
                          isMulti
                          cacheOptions
                          value={customerOption}
                          loadOptions={fetchOptionsAutoCustomer}
                          onChange={(selectedOptions) => {
                            const removed = customerOption.filter(
                              (oldItem) =>
                                !selectedOptions?.some(
                                  (newItem) => newItem.value === oldItem.value
                                )
                            );

                            setCustomerOption(selectedOptions);
                          }}
                          defaultOptions
                          placeholder="Search customer..."
                          styles={multiselectCustomStyles}
                          isClearable={false}
                        />
                      </div>
                    </div>

                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        From Address
                      </div>
                      <div className="w-100">
                        <AsyncSelect
                          isMulti
                          cacheOptions
                          value={fromAddressOption}
                          loadOptions={fetchFromAddress}
                          onChange={(selectedOptions) => {
                            const removed = fromAddressOption.filter(
                              (oldItem) =>
                                !selectedOptions?.some(
                                  (newItem) => newItem.value === oldItem.value
                                )
                            );

                            /* if (removed.length > 0) {
      setRemoveSupplierList((prev) => [...prev, ...removed]);
    } */

                            setFromAddressOption(selectedOptions);
                          }}
                          defaultOptions
                          placeholder="Search from address..."
                          styles={multiselectCustomStyles}
                          isClearable={false}
                        />
                      </div>
                    </div>

                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        To Address
                      </div>
                      <div className="w-100">
                        <AsyncSelect
                          isMulti
                          cacheOptions
                          value={toAddressOption}
                          loadOptions={fetchToAddress}
                          onChange={(selectedOptions) => {
                            const removed = toAddressOption.filter(
                              (oldItem) =>
                                !selectedOptions?.some(
                                  (newItem) => newItem.value === oldItem.value
                                )
                            );

                            /* if (removed.length > 0) {
      setRemoveSupplierList((prev) => [...prev, ...removed]);
    } */

                            setToAddressOption(selectedOptions);
                          }}
                          defaultOptions
                          placeholder="Search to address..."
                          styles={multiselectCustomStyles}
                          isClearable={false}
                        />
                      </div>
                    </div>
                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        Date range
                      </div>
                      <div className="w-100">
                        <CustomDateRangePicker
                          onChange={handleDateChange}
                          startDate={startDate}
                          endDate={endDate}
                        />
                      </div>
                    </div>

                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        Type
                      </div>
                      <div className="w-100">
                        <CommonStaticDropdown
                          items={[
                            {
                              value: "",
                              label: "Select",
                            },
                            {
                              value: "transport_stop_products.quantity",
                              label: "Quantity",
                            },
                            {
                              value: "transport_stop_products.weight",
                              label: "Weight",
                            },
                            {
                              value: "transport_stop_products.price",
                              label: "Price",
                            },
                          ]}
                          placeholder="Select"
                          value={typeOption}
                          enableSearch={false}
                          onSelect={(item) => {
                            setTypeOption(item);
                          }}
                        />
                      </div>
                    </div>

                    <div className="mt-2 col-12 col-md-4 d-flex flex-column align-items-start">
                      <div
                        className="form-label fs-12 fw-400 my-0 mb-1"
                        style={{ color: "#28303F" }}
                      >
                        Value
                      </div>
                      <div className="w-100">
                        <input
                          type="text"
                          className="form-control rounded-3 vendor-form-input"
                          id={`type-value`}
                          placeholder="Enter here"
                          value={typeValue}
                          onChange={(e) => {
                            setTypeValue(
                              e.target.value
                                .replace(/[^0-9.]/g, "")
                                .replace(/(\..*)\./g, "$1")
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFFAE5" }}
                >
                  <img src={totalAmtIc} alt="total amount" />
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Amount
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {totalAmount}
                    </div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#EAFFF3" }}
                >
                  <img src={totalKMIc} alt="totalKMIc" />
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Kilometer
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {totalKM}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#F0F1FF" }}
                >
                  <img src={totalVolumeIc} alt="totalVolumeIc" />
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Volume
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {totalVolume}
                    </div>
                  </div>
                </div>

                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#FFEBEB" }}
                >
                  <img src={totalPackageIc} alt="totalPackageIc" />
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Package
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1"
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {totalPackage}
                    </div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-4 col-lg-2 rounded-3 p-2 d-flex align-items-center justify-content-start"
                  style={{ background: "#F7F2FF" }}
                >
                  <img src={totalWeightIc} alt="totalWeightIc" />
                  <div className="ms-2">
                    <div
                      className="fs-12 fw-400"
                      style={{ color: "#8790A1", textAlign: "start" }}
                    >
                      Total Weight
                    </div>
                    <div
                      className="fs-16 fw-600 mt-1 "
                      style={{ color: "#172B4D", textAlign: "start" }}
                    >
                      {totalWeight}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between px-2">
                <div className="fs-14 fw-700" style={{ color: "#28303F" }}>
                  Stops ({totalCount})
                </div>

                <div className="my-2 d-flex align-items-center gap-2">
                  <Dropdown>
                    <span className="pagination-color">
                      Records per page: &nbsp;
                    </span>
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
                    >
                      <span
                        className="bg-white textcolor no-of-rows rounded-3 px-2 py-2"
                        style={{ border: "1px solid #EBEBEB" }}
                      >
                        {itemsPerPage} <DownArrowIc />
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      className="my-2"
                      style={{ minWidth: "unset", width: "30%" }}
                    >
                      {[10, 25, 50, 75, 100].map((size) => (
                        <Dropdown.Item
                          key={size}
                          onClick={() => {
                            setItemsPerPage(size);
                          }}
                          active={itemsPerPage === size}
                          className="text-center"
                        >
                          {size}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "16px",
                    }}
                  >
                    <span>
                      {itemOffset + 1} of {pageCount}
                    </span>
                    <button
                      className="bg-white"
                      onClick={() => {
                        if (itemOffset > 0) {
                          setItemOffset(itemOffset - 1);
                        }
                      }}
                      disabled={itemOffset === 0}
                      style={{
                        cursor: "pointer",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      &lt;
                    </button>
                    <button
                      className="bg-white"
                      onClick={() => {
                        if (itemOffset < pageCount - 1) {
                          setItemOffset(itemOffset + 1);
                        }
                      }}
                      disabled={pageCount === 0 || itemOffset === pageCount - 1}
                      style={{
                        cursor: "pointer",
                        width: "32px",
                        height: "32px",
                        borderRadius: "100px",
                        border: "1px solid #EBEBEB",
                      }}
                    >
                      &gt;
                    </button>
                  </div>

                  <Button
                    className={`cursor-pointer dark-purple-btn ${
                      isSortLoading ? "disabled-btn" : ""
                    } rounded-3 py-2 px-2 d-flex justify-content-center align-items-center fs-15 fw-500`}
                    onClick={() => {
                      getSortedStops();
                    }}
                    style={{ minWidth: "80px" }}
                  >
                    {isSortLoading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Sort Stops"
                    )}
                  </Button>
                </div>
              </div>
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  fontSize: "12px",
                  fontWeight: 400,
                  color: "#FF4444",
                  marginTop: "6px",
                  marginLeft: "6px",
                }}
              >
                {errorMsg.stops}
              </span>
              <div
                className="px-2 "
                style={{
                  width: "100%",
                  overflowX: "auto",
                  overflowY: "visible",
                  whiteSpace: "nowrap",
                }}
              >
                <div style={{ overflowX: "auto", width: "100%" }}>
                  <table
                    border="1"
                    cellPadding="10"
                    style={{ minWidth: "800px", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr>
                        <th className="trip-table-header">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th className="trip-table-header">SEQ.NO</th>
                        <th className="trip-table-header">CUSTOMER NAME</th>
                        <th className="trip-table-header">STOP ID</th>
                        <th className="trip-table-header">PRODUCT NAME</th>
                        <th className="trip-table-header">FROM ADDRESS</th>
                        <th className="trip-table-header">TO ADDRESS</th>
                        <th className="trip-table-header">UNIT</th>
                        <th className="trip-table-header">WEIGHT</th>
                        <th className="trip-table-header">QUANTITY</th>
                        <th className="trip-table-header">PRICE</th>
                        <th className="trip-table-header">PACKAGE</th>
                        <th className="trip-table-header">DATE TIME</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(stopsList ?? []).map((row, index) => (
                        <tr key={index}>
                          <td className="trip-table-row">
                            <input
                              type="checkbox"
                              checked={row.selected}
                              onChange={() => handleRowSelect(index)}
                            />
                          </td>
                          <td className="trip-table-row text-center">
                            <input
                              type="number"
                              value={row.sequence}
                              onChange={(e) => {
                                stopsList[index]["sequence"] = e.target.value
                                  .replace(/[^0-9.]/g, "")
                                  .replace(/(\..*)\./g, "$1");
                                setStopsList([...stopsList]);
                              }}
                              style={{
                                width: "60px",
                                border: "1px solid #EBEBEB",
                                borderColor: row.error ? "#FF4444" : "#EBEBEB",
                              }}
                              disabled={row.error ? true : false}
                            />
                            {row.error && (
                              <div
                                className="fs-8 fw-100"
                                style={{
                                  color: "#FF4444",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "50px",
                                }}
                                title={row.error}
                              >
                                {row.error}
                              </div>
                            )}
                          </td>
                          <td className="trip-table-row">
                            {row.customer_code}
                          </td>
                          <td className="trip-table-row">{row.stop_code}</td>
                          <td className="trip-table-row">{row.product_name}</td>
                          <td className="trip-table-row">{row.from_address}</td>
                          <td className="trip-table-row">{row.to_address}</td>
                          <td className="trip-table-row">{row.unit}</td>
                          <td className="trip-table-row">{row.weight}</td>
                          <td className="trip-table-row">{row.quantity}</td>
                          <td className="trip-table-row">{row.price}</td>
                          <td className="trip-table-row">{row.package}</td>
                          <td className="trip-table-row">{row.created_date}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 9999 }}
      >
        <Toast
          onClose={() => setToast({ ...toast, show: false })}
          show={toast.show}
          delay={3000}
          autohide
          bg={toast.variant}
        >
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};
